@if (authError()) {
  <div class="flex w-full h-full items-center justify-center">
    <div class="flex flex-col items-center gap-4 max-w-md text-center p-8">
      @if (authError() === 'unavailable') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          fill="currentColor"
          class="icon"
          style="width: 48px; height: 48px; color: var(--color-warning, #f59e0b)"
        >
          <path
            d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
          />
        </svg>
        <h2 class="heading-md">Authentication service unavailable</h2>
        <p class="body-sm fg-secondary">
          The login service could not be reached. Please check your connection and try again.
        </p>
      } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          fill="currentColor"
          class="icon"
          style="width: 48px; height: 48px; color: var(--color-fg-danger-default, #ef4444)"
        >
          <path
            d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
          />
        </svg>
        <h2 class="heading-md">Session error</h2>
        <p class="body-sm fg-secondary">
          Your login session could not be validated. This can happen after a browser refresh during
          login. Please try logging in again.
        </p>
      }
      <button class="button button--primary" (click)="retryLogin()">
        {{ authError() === 'unavailable' ? 'Try again' : 'Login again' }}
      </button>
    </div>
  </div>
} @else {
  <div class="flex w-full h-full">
    <section class="sidebar sidebar--alt" [ngClass]="{ 'sidebar--rail': !isSideBarOpen() }">
      <div class="flex gap-2 flex--align-center">
        @if (isSideBarOpen()) {
          <span class="heading-md flex-grow-full"
            >Identity<span class="fg-primary">Admin</span>
            @if (environmentName === 'staging') {
              <span>QA</span>
            } @else if (environmentName === 'dev') {
              <span>Dev</span>
            }
          </span>
        }
        <button class="button button--quiet button--large" (click)="toggleSidebar()">
          @if (isSideBarOpen()) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              fill="currentColor"
              class="button__icon icon"
            >
              <path
                d="M660-320v-320L500-480l160 160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-80v-560H200v560h120Zm80 0h360v-560H400v560Zm-80 0H200h120Z"
              />
            </svg>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              fill="currentColor"
              class="button__icon icon"
            >
              <path
                d="M500-640v320l160-160-160-160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-80v-560H200v560h120Zm80 0h360v-560H400v560Zm-80 0H200h120Z"
              />
            </svg>
          }
        </button>
      </div>
      <nav class="flex-1">
        <ul class="navigation-list">
          <li>
            <a class="item" [ngClass]="{ 'item--vertical': !isSideBarOpen() }" [routerLink]="['/']">
              <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                <path
                  d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"
                />
              </svg>
              <span>Home</span></a
            >
          </li>
          @if (canManageRealms()) {
            <li>
              <a
                class="item"
                [ngClass]="{ 'item--vertical': !isSideBarOpen() }"
                [routerLink]="['/attributes']"
              >
                <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"
                  />
                </svg>

                <span>Attributes</span>
              </a>
            </li>
          }
          @if (canQueryClients()) {
            <li>
              <a
                class="item"
                [ngClass]="{ 'item--vertical': !isSideBarOpen() }"
                [routerLink]="['/clients']"
              >
                <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm240 0q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm240 0q-33 0-56.5-23.5T640-240q0-33 23.5-56.5T720-320q33 0 56.5 23.5T800-240q0 33-23.5 56.5T720-160ZM240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400ZM240-640q-33 0-56.5-23.5T160-720q0-33 23.5-56.5T240-800q33 0 56.5 23.5T320-720q0 33-23.5 56.5T240-640Zm240 0q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Zm240 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640Z"
                  />
                </svg>
                <span>Clients</span></a
              >
            </li>
          }
          @if (canQueryUsers()) {
            <li>
              <a
                class="item"
                [ngClass]="{ 'item--vertical': !isSideBarOpen() }"
                [routerLink]="['/users']"
              >
                <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"
                  />
                </svg>
                <span>Users</span></a
              >
            </li>
          }
          @if (canQueryGroups()) {
            <li>
              <a
                class="item"
                [ngClass]="{ 'item--vertical': !isSideBarOpen() }"
                [routerLink]="['/groups']"
              >
                <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
                  />
                </svg>
                <span>Groups</span></a
              >
            </li>
          }
          <li>
            <a
              class="item"
              [class.item--vertical]="!isSideBarOpen()"
              [routerLink]="['/client-requests/mine']"
            >
              <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                <path
                  d="M480-120 80-350v-260l400-230 400 230v260l-400 230Zm0-92 320-184v-148L480-360 160-544v148l320 184Zm0-276 317-183-317-183-317 183 317 183Zm0 276Zm0-276Z"
                />
              </svg>
              <span>My Requests</span></a
            >
          </li>
          @if (isRealmAdmin()) {
            <li>
              <a
                class="item"
                [class.item--vertical]="!isSideBarOpen()"
                [routerLink]="['/client-requests']"
              >
                <svg class="item__icon icon" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="M480-120 80-350v-260l400-230 400 230v260l-400 230Zm0-92 320-184v-148L480-360 160-544v148l320 184Zm0-276 317-183-317-183-317 183 317 183Zm0 276Zm0-276Z"
                  />
                </svg>
                <span>Client Requests</span></a
              >
            </li>
          }
        </ul>
      </nav>
      <div class="">
        <ul class="navigation-list">
          <li class="divider"></li>
          <li class="item" [ngClass]="{ 'item--vertical': !isSideBarOpen() }">
            <svg
              class="item__icon icon"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            @if (isSideBarOpen() && userProfile() != undefined) {
              <span class="item__text">{{ userProfile()?.name }}</span>
            }
          </li>
          <li>
            <button
              class="item"
              [ngClass]="{ 'item--vertical': !isSideBarOpen() }"
              (click)="logoutUser()"
            >
              <span class="item__text">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </section>
    <main class="flex flex-col items-center flex-1 overflow-auto relative">
      @if (isAuthenticated()) {
        <router-outlet></router-outlet>
      }

      <!-- User Edit Sidebar -->
      @if (sidebarService.isOpen() && sidebarService.getComponent() === 'user-edit') {
        <div class="fixed inset-0 z-50 flex">
          <!-- Backdrop -->
          <div class="backdrop" (click)="sidebarService.closeSidebar()"></div>

          <!-- Sidebar Panel -->
          <div
            class="relative ml-auto w-full max-w-2xl bg-white shadow-xl flex flex-col h-full overflow-hidden z-[102]"
          >
            <div class="flex-1 overflow-y-auto">
              <app-user-edit
                [isSidebarMode]="true"
                [userIdInput]="$safeNavigationMigration($any(sidebarService.getData())?.userId)"
                [userInput]="$safeNavigationMigration($any(sidebarService.getData())?.user)"
              >
              </app-user-edit>
            </div>
          </div>
        </div>
      }

      <!-- Group Edit Sidebar -->
      @if (sidebarService.isOpen() && sidebarService.getComponent() === 'group-edit') {
        <div class="fixed inset-0 z-50 flex">
          <!-- Backdrop -->
          <div class="backdrop" (click)="sidebarService.closeSidebar()"></div>

          <!-- Sidebar Panel -->
          <div
            class="relative ml-auto w-full max-w-2xl bg-white shadow-xl flex flex-col h-full overflow-hidden z-[102]"
          >
            <div class="flex-1 overflow-y-auto">
              <app-group-edit
                [isSidebarMode]="true"
                [groupIdInput]="$safeNavigationMigration($any(sidebarService.getData())?.groupId)"
                [groupInput]="$safeNavigationMigration($any(sidebarService.getData())?.group)"
              >
              </app-group-edit>
            </div>
          </div>
        </div>
      }
    </main>
  </div>
}
